import _ from 'underscore';
import 'edge/quoteandbind/common/models/Submission';
import 'edge/quoteandbind/common/models/Person';

var WCSubmissionDataExtension = function WCSubmissionDataExtension(submission) {

    var wcData = submission.lobData.workersComp;
    if (wcData) {
        this.preQualQuestionSets = wcData.preQualQuestionSets || [];
        this.generalInfoQuestionSets = wcData.generalInfoQuestionSets || [];
        /*
        this.offerings = paData.offerings || [];
        this.coverables = new PACoverables(wcData.coverables, submission);
        */
    }
};

export default WCSubmissionDataExtension;


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/edge/quoteandbind/wc/models/WCSubmissionDataExtension.js
// module id = 1310
// module chunks = 0